var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBook20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#book-20_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.255,
  d: "M10 6.901c0-1.208-.98-2.187-2.188-2.187H3.62c-.604 0-1.094.49-1.094 1.093v8.386c0 .604.49 1.093 1.094 1.093h3.99c.497 0 .983.12 1.405.381.422.26.763.634.985 1.078M10 6.9c0-1.208.98-2.187 2.188-2.187h4.192c.604 0 1.094.49 1.094 1.093v8.386c0 .604-.49 1.093-1.094 1.093h-3.99c-.497 0-.983.12-1.405.381-.422.26-.763.634-.985 1.078M10 6.9v9.844"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "book-20_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.75 1.25H1.25v17.5h17.5z"
})))));
export default SvgBook20;